import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import GroupWithExpirationRecord from "models/view-models/group-with-expiration-record";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------
interface ListPathParams {
    id: number;
}

interface ListQueryParams {}
// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "groups/eligible";
const userListEndpoint = `${baseEndpoint}/:id`;
const resourceType = GroupWithExpirationRecord;
const key = "groups-eligible";

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const GroupEligibleGroupService = {
    key,
    /**
     * Retrieves a list of Group resources that are eligible to be applied to a new UserSubscription
     */
    list: ServiceFactory.list(resourceType, baseEndpoint),
    userList: ServiceFactory.nestedList<
        GroupWithExpirationRecord,
        ListPathParams,
        ListQueryParams
    >(resourceType, userListEndpoint),

    /**
     * Custom hook for leveraging service list calls in react components
     */
    useList: ServiceHookFactory.useList(resourceType, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default GroupEligibleGroupService;

// #region Exports
